import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, IconButtonProps } from "@mui/material";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  cursor: "pointer",
  color: theme.palette.redAlert.main,
  fontSize: 16,
  marginTop: -0.5,
  height: 18,
  "&:focus": {
    outline: 0,
  },
  "&.MuiIconButton-root": {
    padding: 0,
    paddingLeft: "5px",
  },
}));

export const StyledDeleteButton = (props: IconButtonProps) => (
  <StyledIconButton {...props}>
    <DeleteIcon />
  </StyledIconButton>
);
